// 細かい動きの下ごしらえ（見た目は yj-motion.css）。
// ・最初に触ったら <html> に .yj-live（選んだ瞬間のふくらみは、触ってから。読み込み直後に一斉に跳ねないように）
// ・実写の並び（.worn .photos）は、まだ画面の外にあれば待たせておき、入ったら右から順に滑り込ませる
(() => {
  const root = document.documentElement;
  const live = () => root.classList.add('yj-live');
  addEventListener('pointerdown', live, { once: true, capture: true });
  addEventListener('keydown', live, { once: true, capture: true });
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: .2 });
  const arm = () => document.querySelectorAll('.worn .photos').forEach(el => {
    if (el.dataset.yjIn) return;
    el.dataset.yjIn = '1';
    if (el.getBoundingClientRect().top < innerHeight) return;   // 最初から見えている分は動かさない
    [...el.children].forEach((c, i) => c.style.setProperty('--i', Math.min(i, 5)));
    el.classList.add('yj-in-wait');
    io.observe(el);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();
